import React, { SVGProps } from 'react';

const SvgVerified = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' fill='currentColor' className='svg-icon' {...props}>
			<path fill='none' d='M0 0h24v24H0z' />
			<path
				d='M18.49 9.88l.08-.85.18-1.95-1.9-.43-.84-.19-.44-.74-.99-1.68-1.79.76-.79.34-.79-.34-1.79-.77-.99 1.68-.44.74-.84.19-1.9.43.18 1.94.08.85-.56.65-1.29 1.48 1.29 1.47.56.65-.08.85-.18 1.96 1.9.43.84.19.44.74.99 1.67 1.78-.77.8-.33.79.34 1.78.77.99-1.68.44-.74.84-.19 1.9-.43-.18-1.95-.08-.85.56-.65L20.33 12l-1.29-1.47-.55-.65zm-8.4 6.84l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z'
				opacity={0.3}
			/>
			<path d='M23 11.99L20.56 9.2l.34-3.69-3.61-.82L15.4 1.5 12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 11.99l2.44 2.79-.34 3.7 3.61.82 1.89 3.2 3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69 2.44-2.8zm-3.95 1.48l-.56.65.08.85.18 1.95-1.9.43-.84.19-.44.74-.99 1.68-1.78-.77-.8-.34-.79.34-1.78.77-.99-1.67-.44-.74-.84-.19-1.9-.43.18-1.96.08-.85-.56-.65L3.67 12l1.29-1.48.56-.65-.09-.86-.18-1.94 1.9-.43.84-.19.44-.74.99-1.68 1.78.77.8.34.79-.34 1.78-.77.99 1.68.44.74.84.19 1.9.43-.18 1.95-.08.85.56.65 1.29 1.47-1.28 1.48z' />
			<path d='M10.09 13.75l-2.32-2.33-1.48 1.49 3.8 3.81 7.34-7.36-1.48-1.49z' />
		</svg>
	);
};

export default SvgVerified;
